import { defineMessages } from 'react-intl';

export default defineMessages({
	buttonLabel: {
		id: 'components.walletPayment.walletTransactionModal.buttonLabel',
		defaultMessage: 'بستن',
	},
});
